import React, { useEffect, useRef, useState } from "react";
import { Transition } from "react-transition-group";

import BookingForm from "./BookingForm";
import CtmPhone from "./CtmPhone";

const iconContact = new URL(
  "../assets/images/icon-contact.svg",
  import.meta.url
);
const iconContactYellow = new URL(
  "../assets/images/icon-contact-yellow.svg",
  import.meta.url
);
const iconCamera = new URL("../assets/images/icon-camera.svg", import.meta.url);
const iconPhone = new URL("../assets/images/icon-phone.svg", import.meta.url);

const duration = 300;
const defaultStyle = {
  transition: `all ${duration}ms ease-in-out`,
  opacity: 0,
  height: 0,
};
const transitionStyles = {
  entering: { opacity: 1, height: "125px" },
  entered: { opacity: 1, height: "125px" },
  exiting: { opacity: 0, height: 0 },
  exited: { opacity: 0, height: 0 },
};

export default function ContactButton({
  position,
  positionDefault,
  visible,
  showBookingForm,
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const nodeRef = useRef(null);

  useEffect(() => {
    setShowDropdown(false);
  }, [position]);

  const showDropdownHandle = () => {
    setShowDropdown(!showDropdown);
  };

  const getPositionStyles = () => {
    if (position === positionDefault) {
      return { top: `${window.innerHeight - 240}px` };
    } else {
      return {
        bottom: `${position}px`,
      };
    }
  };

  return (
    <div
      className="fixed z-30 rounded-md w-[240px] mx-auto bg-yellow transition-all duration-500 overflow-hidden"
      style={{
        ...{
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
          left: "50%",
          marginLeft: "-120px",
          opacity: visible ? 1 : 0,
        },
        ...getPositionStyles(),
      }}
    >
      <div className="flex flex-col">
        <button
          className={`rounded-md ${
            showDropdown
              ? "bg-dark-blue text-yellow"
              : "bg-[#FFD86C] text-dark-blue"
          }`}
          onClick={showDropdownHandle}
        >
          <div className="flex items-center justify-center px-5 p-4 gap-3">
            <div className="mr-2">
              <img
                src={showDropdown ? iconContactYellow : iconContact}
                width={36}
              />
            </div>
            <div className="font-intermedium text-[20px]">Kontakta oss</div>
          </div>
        </button>
        <Transition nodeRef={nodeRef} in={showDropdown} timeout={duration}>
          {(state) => (
            <div
              ref={nodeRef}
              style={{
                ...defaultStyle,
                ...transitionStyles[state],
              }}
            >
              <>
                <button className="w-full">
                  <div className="flex items-center justify-center px-5 pt-4 pb-4 gap-3">
                    <div className="mr-2">
                      <img src={iconPhone} />
                    </div>
                    <div className="font-intermedium text-[20px]">
                      <CtmPhone underlined={false} />
                    </div>
                  </div>
                </button>
                <hr className="border-dark-blue mx-5" />
                <button
                  className="w-full"
                  onClick={() => {
                    showBookingForm(true);
                    showDropdownHandle();
                  }}
                >
                  <div className="flex items-center justify-center px-5 pt-4 pb-4 gap-3">
                    <div className="mr-2">
                      <img src={iconCamera} width={24} />
                    </div>
                    <div className="font-intermedium text-[20px]">
                      BOKA MÖTE
                    </div>
                  </div>
                </button>
              </>
            </div>
          )}
        </Transition>
      </div>
    </div>
  );
}
